import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Icon } from "@/lib/ui";

const NAV = [
  { to: "/admin", icon: "LayoutDashboard", label: "Dashboard", end: true },
  { to: "/admin/tags", icon: "Tags", label: "All Tags" },
  { to: "/admin/generate", icon: "QrCode", label: "Generate" },
  { to: "/admin/users", icon: "Users", label: "Users" },
  { to: "/admin/categories", icon: "FolderTree", label: "Categories" },
  { to: "/admin/themes", icon: "Palette", label: "Themes" },
  { to: "/admin/scans", icon: "Radar", label: "Scans" },
  { to: "/admin/messages", icon: "MessagesSquare", label: "Finder Messages" },
  { to: "/admin/audit", icon: "ScrollText", label: "Audit Logs" },
  { to: "/admin/settings", icon: "Settings", label: "Settings" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <div className="min-h-screen bg-secondary/30 flex">
      {/* Sidebar */}
      <aside className={`fixed lg:static z-50 inset-y-0 left-0 w-64 bg-background border-r border-border flex flex-col transition-transform ${open ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}>
        <div className="h-16 flex items-center gap-2 px-5 border-b border-border font-display font-extrabold text-lg tracking-tight">
          <span className="grid place-items-center w-8 h-8 rounded-lg bg-primary text-primary-foreground"><Icon name="ScanLine" className="w-5 h-5" /></span>
          TagBack <span className="text-xs font-semibold text-muted-foreground">Admin</span>
        </div>
        <nav className="flex-1 overflow-y-auto p-3 space-y-1">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} onClick={() => setOpen(false)}
              data-testid={`admin-nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-semibold transition-colors ${isActive ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:bg-secondary"}`}>
              <Icon name={n.icon} className="w-4.5 h-4.5" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-border">
          <div className="px-3 py-2 text-xs text-muted-foreground truncate">{user?.email}</div>
          <button data-testid="admin-logout" onClick={logout} className="tap w-full flex items-center gap-2 px-3 py-2.5 rounded-xl text-sm font-semibold text-status-lost hover:bg-secondary">
            <Icon name="LogOut" className="w-4 h-4" /> Log out
          </button>
        </div>
      </aside>

      {open && <div className="fixed inset-0 bg-black/40 z-40 lg:hidden" onClick={() => setOpen(false)} />}

      <div className="flex-1 min-w-0 flex flex-col">
        <header className="h-16 border-b border-border bg-background/80 backdrop-blur-xl flex items-center px-5 gap-3 lg:hidden">
          <button onClick={() => setOpen(true)} className="tap"><Icon name="Menu" className="w-6 h-6" /></button>
          <span className="font-display font-bold">TagBack Admin</span>
        </header>
        <main className="flex-1 p-5 lg:p-8 overflow-x-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
